import { Trans } from '@lingui/react/macro';
import TextLink from './TextLink';
import { TestIds } from '@watershed/shared-universal/utils/testUtils';
// Import shared components from within ui-core
import { Error, FlexiError } from './shared/ErrorDisplayComponents';
import { routeForSupport } from '@watershed/shared-universal/dashboardRoutes';

export function UnexpectedErrorState() {
  // Create a generic error object for the icon
  // Since this is "unexpected", we don't have a specific code.
  const unexpectedError: FlexiError = {
    name: 'UnexpectedError',
    message: 'Something went wrong',
    // code: undefined or a generic code like 'UNEXPECTED' could be used if needed by getIconsForError
  };

  return (
    <Error.Root>
      <Error.Icon error={unexpectedError} />
      <Error.Title>
        <Trans context="Generic error message header">
          Something went wrong
        </Trans>
      </Error.Title>
      <Error.Description data-testid={TestIds.UnexpectedErrorPageBody}>
        <Trans context="Generic error message content">
          Our engineering team has been notified and will investigate the issue.
          Reloading the page or hitting the back button in your browser may
          resolve the issue. If you have additional questions, please visit the{' '}
          <TextLink href={routeForSupport()}>support center</TextLink>.
        </Trans>
      </Error.Description>
    </Error.Root>
  );
}
